import React from 'react';

import {Text} from '@famly/mf_data-display_text';
import {Stack} from '@famly/mf_layout_stack';

export type MfLookalikeTagProps = {
    /**
     * Controls the background color.
     */
    backgroundColor: Extract<ColorKey, 'p100' | 'b100' | 'g100' | 'y100' | 'n0' | 'g400' | 'n75'>;

    /**
     * The label of the category.
     */
    label: string;
    textColor?: Extract<ColorKey, 'n0' | 'n400'>;
};

export const MfLookalikeTag = ({backgroundColor, label, textColor = 'n400'}: MfLookalikeTagProps) => {
    return (
        <Stack
            boxSizing="border-box"
            backgroundColor={backgroundColor}
            border={backgroundColor === 'n0' ? 'n100' : undefined}
            alignItems="center"
            justifyContent="flex-start"
            borderRadius="8px"
            paddingX={2}
            height="24px"
            whiteSpace="nowrap"
        >
            <Text variant="body-small" color={textColor}>
                {label}
            </Text>
        </Stack>
    );
};
